<template>
    <div>
        <b-button class="w-100 mb-1"
                  variant="outline-secondary"
                  v-show="!servicestatus.flap_detection_enabled"
                  @click="enableFlap">
            <i class="fa-solid fa-circle-half-stroke"></i>
            {{ $t('action-items.flap-detection-enable') }}
        </b-button>
        <b-button class="w-100 mb-1"
                  variant="outline-secondary"
                  v-show="servicestatus.flap_detection_enabled"
                  @click="disableFlap">
            <i class="fa-solid fa-circle-half-stroke"></i>
            {{ $t('action-items.flap-detection-disable') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: "Flap",
    props: [
        'uuids',
        'servicestatus'
    ],
    methods: {
        enableFlap(){
            console.log('enable');
            let externalCommands = [];
            externalCommands.push({
              /*  serviceUuid: this.uuids.serviceuuid,
                hostUuid: this.uuids.hostuuid,
                command: 'ENABLE_SVC_FLAP_DETECTION' */

                command: 'enableOrDisableServiceFlapdetection',
                hostUuid: this.uuids.hostuuid,
                serviceUuid: this.uuids.serviceuuid,
                condition: 1,

            });
            this.$emit('command', externalCommands, 'submit');
        },
        disableFlap(){
            let externalCommands = [];
            externalCommands.push({
                command: 'enableOrDisableServiceFlapdetection',
                hostUuid: this.uuids.hostuuid,
                serviceUuid: this.uuids.serviceuuid,
                condition: 0,
            })
            this.$emit('command', externalCommands, 'submit');
        },
    }
}
</script>

<style scoped>

</style>
